var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuestosSanitarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 33.3333H41.6667C37.2464 33.3333 33.0072 35.0893 29.8816 38.2149C26.7559 41.3405 25 45.5797 25 50V79.1667C25 91.3224 29.8289 102.98 38.4243 111.576C47.0197 120.171 58.6776 125 70.8333 125C82.9891 125 94.647 120.171 103.242 111.576C111.838 102.98 116.667 91.3224 116.667 79.1667V50C116.667 45.5797 114.911 41.3405 111.785 38.2149C108.66 35.0893 104.42 33.3333 100 33.3333H91.6667M66.6667 125C66.6667 131.566 67.96 138.068 70.4727 144.134C72.9854 150.2 76.6684 155.712 81.3113 160.355C85.9543 164.998 91.4662 168.681 97.5325 171.194C103.599 173.707 110.101 175 116.667 175C123.233 175 129.735 173.707 135.801 171.194C141.867 168.681 147.379 164.998 152.022 160.355C156.665 155.712 160.348 150.2 162.861 144.134C165.373 138.068 166.667 131.566 166.667 125V100M166.667 100C162.246 100 158.007 98.244 154.882 95.1184C151.756 91.9928 150 87.7536 150 83.3333C150 78.9131 151.756 74.6738 154.882 71.5482C158.007 68.4226 162.246 66.6667 166.667 66.6667C171.087 66.6667 175.326 68.4226 178.452 71.5482C181.577 74.6738 183.333 78.9131 183.333 83.3333C183.333 87.7536 181.577 91.9928 178.452 95.1184C175.326 98.244 171.087 100 166.667 100ZM91.6667 25V41.6667M50 25V41.6667",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuestosSanitarios);
export default __webpack_public_path__ + "static/media/PuestosSanitarios.5663e3b23641590fd79f6e79a1d78684.svg";
export { ForwardRef as ReactComponent };